export const API_CONFIG = {
  baseURL: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:3001'
    : '',
} as const;

export const AI_CONFIG = {
  model: 'claude-3-5-haiku-20241022',
  maxTokens: 8192,
  temperature: 0.2,
} as const; 